<script setup lang="ts">
defineProps<{ horizontal?: boolean }>();
</script>

<template>
  <div class="menu-item-delimiter" :class="{ horizontal }" />
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

.menu-item-delimiter {
  width: 2px;
  height: 16px;
  background-color: colors.$border-subtle;
  margin-left: 4px;
  margin-right: 4px;

  &.horizontal {
    width: 16px;
    height: 2px;
    margin: 4px 0;
  }
}
</style>
